import { render } from "./School.vue?vue&type=template&id=26c38b65&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"

import "./School.vue?vue&type=style&index=0&id=26c38b65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c38b65"]])

export default __exports__